<div class="container-fluid custom-date-filter">
    <div class="row justify-content-end">
        <div class="col-lg-10">
            <div class="d-flex justify-content-end align-items-start flex-wrap gap-2">

                <!-- From Date -->
                <div class="date-field">
                    <label>From Date</label>
                    <div class="input-group">
                        <input class="form-control" name="frmDate" [(ngModel)]="fromDate" autocomplete="off"
                            ngbDatepicker #d1="ngbDatepicker" container="body" placeholder="From Date">

                        <span class="input-group-text pointer" (click)="d1.toggle()">
                            <i class="bi bi-calendar"></i>
                        </span>
                    </div>
                </div>

                <!-- To Date -->
                <div class="date-field">
                    <label>To Date</label>
                    <div class="input-group">
                        <input class="form-control" name="toDate" [(ngModel)]="toDate" autocomplete="off" ngbDatepicker
                            #d2="ngbDatepicker" container="body" placeholder="To Date">

                        <span class="input-group-text pointer" (click)="d2.toggle()">
                            <i class="bi bi-calendar"></i>
                        </span>
                    </div>
                </div>

                <!-- Buttons -->
                <div class="button-group">
                    <button class="btn btn-success btn-sm me-2" (click)="onSubmit()">
                        Submit
                    </button>

                    <button class="btn btn-danger btn-sm" (click)="onClear()">
                        Clear
                    </button>
                </div>

            </div>
        </div>
    </div>
</div>